module.exports = __webpack_public_path__ + "img/chevron-down.f5708d62.svg";